import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AlertTosterService {
  constructor(protected toserService: ToastrService) {}

  success(
    message: string,
    title = '',
    positionClass = 'toast-top-right',
    timeOut = 2000,
    tapToDismiss = true
  ) {
    this.toserService.success(message, title, {
      positionClass: positionClass,
      timeOut: timeOut,
      tapToDismiss: tapToDismiss
    });
  }

  error(
    message: string,
    title = '',
    positionClass = 'toast-top-right',
    timeOut = 2000,
    tapToDismiss = true
  ) {
    this.toserService.error(message, title, {
      positionClass: positionClass,
      timeOut: timeOut,
      tapToDismiss: tapToDismiss
    });
  }

  warning(
    message: string,
    title = '',
    positionClass = 'toast-top-right',
    timeOut = 2000,
    tapToDismiss = true
  ) {
    this.toserService.warning(message, title, {
      positionClass: positionClass,
      timeOut: timeOut,
      tapToDismiss: tapToDismiss
    });
  }

  info(
    message: string,
    title = '',
    positionClass = 'toast-top-right',
    timeOut = 2000,
    tapToDismiss = true
  ) {
    this.toserService.info(message, title, {
      positionClass: positionClass,
      timeOut: timeOut,
      tapToDismiss: tapToDismiss
    });
  }

  clear() {
    this.toserService.clear();
  }
}
